import { Theme } from "@mui/material";

export const handleBorderColor = (isCompleted: boolean, isAccordionOpen: boolean, theme: Theme) => {
  if(isCompleted){
    return theme.customColors.borderSecondaryComplete;
  }
  if(isAccordionOpen){
    return theme.customColors.borderAccent;
  }
  return theme.customColors.border;

};
